import { useParams, useSearchParams } from 'react-router-dom';
import { useAccountParam } from 'hooks';

type DeductionParams = {
    referenceId: string,
    accountId: string,
    vendorId: string,
    invoiceId: string,
};

export default function useDeductionParams() : DeductionParams {
    const accountId = useAccountParam();
    const { vendorId = '', invoiceId = '', referenceId: pathReferenceId = '' } = useParams() as Partial<DeductionParams>;
    const [searchParams] = useSearchParams();
    const referenceId = searchParams.get('referenceId') || pathReferenceId;
    return { accountId, vendorId, invoiceId, referenceId };
};
